var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 8.6098C3.72229 8.0146 3.31078 8 2.75253 8C1.89257 8 1.75 8.203 1.75 9V10C1.75 10.797 1.89257 11 2.75253 11C3.31077 11 3.72229 10.9854 3.75 10.3902M10.25 8L9.36145 10.3474C9.19675 10.7825 9.1144 11 8.984 11C8.85355 11 8.7712 10.7825 8.6065 10.3474L7.71795 8M6.438 8H5.84755C5.61155 8 5.4936 8 5.40055 8.03805C5.0836 8.1677 5.0879 8.4724 5.0879 8.75C5.0879 9.02765 5.0836 9.33235 5.40055 9.46195C5.4936 9.5 5.6116 9.5 5.84755 9.5C6.0835 9.5 6.20145 9.5 6.29455 9.53805C6.61145 9.6677 6.60715 9.97235 6.60715 10.25C6.60715 10.5276 6.61145 10.8324 6.29455 10.962C6.20145 11 6.0835 11 5.84755 11H5.20445",
    stroke: "#3F3F3F",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.5V5.32845C10 4.91968 10 4.7153 9.9239 4.53153C9.84775 4.34776 9.70325 4.20325 9.4142 3.91422L7.04595 1.54594C6.7965 1.2965 6.6718 1.17177 6.51725 1.09787C6.4851 1.0825 6.4522 1.06886 6.4186 1.05701C6.25705 1 6.0807 1 5.7279 1C4.10541 1 3.29415 1 2.74466 1.44304C2.63365 1.53254 2.53254 1.63366 2.44303 1.74467C2 2.29416 2 3.10541 2 4.72792V6.5M6.5 1.25V1.5C6.5 2.91421 6.5 3.62132 6.93935 4.06066C7.3787 4.5 8.0858 4.5 9.5 4.5H9.75",
    stroke: "#3F3F3F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsv);
export default __webpack_public_path__ + "static/media/csv.c7b3a24a20676045952f8ba9755c8de8.svg";
export { ForwardRef as ReactComponent };